import { Delete, Visibility } from "@material-ui/icons";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { enableEditEmployee, useDeleteEmployeeMutation, useGetEmployeeListQuery } from "../../../features/admin/employee/employeeSlice";
import Spinner from "../../Spinner";



export default function EmployeeList({ getEmployeeDetails, setEmployeeData }) {
  const dispatch = useDispatch()
  const { data: getEmployeeList, isLoading, refetch } = useGetEmployeeListQuery()
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState()
  const handleClose = () => { setOpen(false) };
  const handleDelete = async () => {
    await deleteEmployee(deleteId);
    refetch()
    handleClose()
  }
  const [deleteEmployee] = useDeleteEmployeeMutation()

  if (isLoading) return <Spinner />;
  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 120,
      disableClickEventBubbling: true,
      renderCell: (data) => {
        const onClick = async (e) => {
          e.stopPropagation();
          const employeeData = await getEmployeeDetails(data.row.id)
          setEmployeeData(employeeData?.data?.data)
          dispatch(enableEditEmployee())
        };
        const onRemove = (e) => {
          e.stopPropagation();
          setDeleteId(data?.id)
          setOpen(true);
        };

        return (
          <>
            <div className="action_btn">
              <span className="view_btn" onClick={onClick}><Visibility /></span>
              <span className="del_btn" onClick={onRemove}><Delete /></span>
            </div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
              <DialogTitle id="alert-dialog-title">
                Delete Confirmation
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this row?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button className="btn-secondary" onClick={handleClose}>Cancel</Button>
                <Button className="btn-primary" onClick={handleDelete}> Confirm</Button>
              </DialogActions>
            </Dialog>
          </>
        )
      },
    },
    { field: "driverNumber", headerName: "Driver", width: 120 },
    { field: "firstname", headerName: "First Name", width: 180 },
    { field: "lastname", headerName: "Last Name", width: 180 },
    { field: "primaryNumber", headerName: "Primary No.", width: 180 },
    { field: "emailAddress", headerName: "Email.", width: 180 },
    { field: "hireDate", headerName: "Date Hired", width: 140 },
    { field: "payrollName", headerName: "Payroll", width: 120 },
    { field: "payrollTypeName", headerName: "Payroll Type", width: 150 },



  ];
  const rows = getEmployeeList?.data.map((data) => {
    return {
      id: data?.employeeId,
      payrollName: data?.payrollName,
      driverNumber: data?.driverNumber,
      firstname: data?.firstname,
      lastname: data?.lastname,
      primaryNumber: data?.primaryNumber,
      hireDate: new Date(data?.hireDate).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),
      payrollTypeName: data?.payrollTypeName,
      emailAddress: data?.emailAddress,
    }
  })

  return (
    <div className="user-role-table">
      <h6>List of Employees</h6>
      <DataGrid rows={rows} columns={columns} pageSize={15} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: { showQuickFilter: true }
        }} />
    </div>
  );
}
